import { Logs } from 'components/Logs';
import { useTaskModal } from '../context.taskModal';

export function TaskLogs() {
  const { task } = useTaskModal();

  return <Logs logs={task?.logs || []} />;
}
